import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";

/**
 * Fetches the org's persona catalog once and returns a lookup keyed by
 * persona id: { [id]: { color, display_name, specialty } }.
 *
 * Used to color and label individual council responses (which carry a
 * persona_id) without threading the full model config through props.
 */
export const usePersonaColors = () => {
  const [personaMap, setPersonaMap] = useState({});

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/settings/models`)
      .then((res) => {
        const personas = res.data?.data?.personas || [];
        const map = {};
        personas.forEach((p) => {
          map[p.id] = {
            color: p.color,
            display_name: p.display_name,
            specialty: p.specialty,
          };
        });
        if (mounted) setPersonaMap(map);
      })
      .catch(() => {
        /* non-fatal: components fall back to model-based labels */
      });
    return () => {
      mounted = false;
    };
  }, []);

  return personaMap;
};

export default usePersonaColors;
